import CorporateTransformer from '../../transformers/corporate';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    window.axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${id}/category-choices`, {
        headers: {
          ignoreLoading: true,
        },
      })
      .then(({ data }) => {
        let dataRes = [];
        if (data) {
          dataRes = CorporateTransformer.transformCategoryChoice(data.data);
        }
        resolve(dataRes);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
